import { FormValues } from '@features/users/adminPanel/components/Form/Form.types.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { apiRoutes } from '@shared/consts/apiRoutes.ts';
import { UserProfileResponse } from '@shared/services/userProfile/service.types.ts';

export async function postUserProfileService(payload: FormValues) {
  return await apiClient.post(apiRoutes.postUserProfile(), payload);
}

export async function putUserProfileService(id: string, payload: FormValues) {
  return await apiClient.put<FormValues, UserProfileResponse>(apiRoutes.putUserProfile(id), payload);
}
